// extracted by mini-css-extract-plugin
export default {"content":"index_content_QSwQZ","other":"index_other_IrQ9B","rules":"index_rules_udQLZ"};